import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import liveServerStatus from "../liveServerStatus";

// Check if environment variables are loaded
const envVarsLoaded = !!process.env.REACT_APP_FIREBASE_API_KEY_LIVE || !!process.env.REACT_APP_FIREBASE_API_KEY_UAT;


// UAT Firebase config
const uatFirebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY_UAT,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_UAT,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_UAT,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_UAT,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_UAT,
    appId: process.env.REACT_APP_FIREBASE_APP_ID_UAT,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_UAT
};

// Live Firebase config
const liveFirebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY_LIVE,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_LIVE,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_LIVE,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_LIVE,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_LIVE,
    appId: process.env.REACT_APP_FIREBASE_APP_ID_LIVE,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_LIVE
};

// If environment variables aren't loaded, warn in console
if (!envVarsLoaded) {
    console.warn(
        "WARNING: Environment variables not loaded. Make sure your .env file is configured correctly. " +
        "Ensure you have REACT_APP_ prefix for all variables and restart your development server after changes."
    );
    
    // Add development check
    if (process.env.NODE_ENV === 'development') {
        console.error("Firebase configuration is missing. Check your .env file configuration.");
    }
}

const configToUse = liveServerStatus ? liveFirebaseConfig : uatFirebaseConfig;

console.log(`Using ${liveServerStatus ? "LIVE" : "UAT"} Firebase configuration.`);
console.log("Environment variables loaded:", envVarsLoaded);

// Initialize Firebase
const app = initializeApp(configToUse);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Define collection references
const myelinersCollectionRef = collection(db, "myeliners");

export { app, auth, db, storage, myelinersCollectionRef };
